import axios from "axios";
import { isDev } from "./misc";
import {
  authRequestInterceptor,
  authResponseInterceptor,
} from "./interceptors";

export const BACKEND_CONFIG = {
  baseURL: isDev ? "http://localhost:3000" : (import.meta.env.VITE_API_BASE_URL ?? "/api"),
  withCredentials: true,
};

const backend = axios.create(BACKEND_CONFIG);

backend.interceptors.request.use(authRequestInterceptor);
backend.interceptors.response.use((res) => res, authResponseInterceptor);

export default backend;
